import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './singlepost.css';
import axios from 'axios';
import React from 'react';
import styles from '../singlepost/singlepost.css';


const SinglePost = () => {

  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 100);

    axios
      .get(`https://cms.gammadda.lk/wp-json/wp/v2/posts?slug=${slug}&_embed`)
      .then(res => setPost(res.data[0]))
      .catch(err => console.error(err));
  }, [slug]);

  if (!post) return <p>Loading...</p>;
  const featuredImage =
    post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null;
  console.log(post); 

  return (

    <div>
      {featuredImage && ( 
    //    <img
    //    src={featuredImage}
    //    alt={post?.title?.rendered || 'Post image'}
    //    className="w-full h-auto object-cover rounded-lg mb-6"
    //  />

    <div 
    className="position-relative overflow-hidden w-100" 
    style={{ height: '70vh', maxHeight: '600px',marginTop: "65px" }}
  >
    {/* Background image with overlay */}
    <div 
      className="position-absolute top-0 start-0 w-100 h-100 custome-iframe"
      style={{
        backgroundImage: `url(${featuredImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 1
      }}
    >
      <div className="w-100 h-100 bg-black" style={{ opacity: 0.5 }}></div>
    </div>
  
    {/* Centered content */}
    <div 
      className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3"
      style={{
        maxWidth: '960px',
        zIndex: 2,
        transition: 'opacity 1s ease, transform 1s ease',
        transform: visible ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
        opacity: visible ? 1 : 0
      }}
    >
      <h1 className="fw-bold text-white mb-4 display-5">{post?.title?.rendered}</h1>
    </div>
  </div>
  
        
      )}
      <div
        className="mt-4   text-lg container text-center "
        dangerouslySetInnerHTML={{ __html: post?.content?.rendered || '' }}
      />

      
    </div>

  )
}

export default SinglePost